const generateShipmentNumber = require('../../shipment/tools/generate-shipment-number')
const { aggregateQuantitiesBySku, updateCountsFromSkuQuantities } = require('../utils')

function createInvoiceCallback ({ mainApi, logger, batches }) {
  return async function invoiceCallback (params) {
    if (!params) {
      const err = new Error('invoiceCallback: order_reference parameter is required')
      err.status = 400
      throw err
    }

    const orders = Array.isArray(params[0].orders) ? params[0].orders : []
    const orderReference = orders[0] && orders[0].order_reference

    if (!orderReference) {
      const err = new Error('invoiceCallback: order_reference parameter is required')
      err.status = 400
      throw err
    }

    const shipmentId = orderReference
    let shipment
    try {
      shipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber: shipmentId })
    } catch (err) {
      const e = new Error(`invoiceCallback: shipment not found for order reference: ${shipmentId}: ${err}`)
      e.status = 404
      throw e
    }
    if (!shipment) {
      const err = new Error(`invoiceCallback: shipment not found for order reference: ${shipmentId}`)
      err.status = 404
      throw err
    }

    const invoiceItems = orders.reduce((acc, order) => {
      if (order && Array.isArray(order.items)) {
        acc.push(...order.items)
      }
      return acc
    }, [])

    if (invoiceItems.length === 0) {
      const err = new Error(`invoiceCallback: items missing for order_reference: ${shipmentId}`)
      err.status = 400
      throw err
    }

    const hasSentSnapshot = ['sent', 'arrived', 'received'].includes(shipment.status)

    await batches.fromInvoice(invoiceItems)

    const invoiceQuantitiesBySku = aggregateQuantitiesBySku(
      invoiceItems,
      item => item && item.invoice_quantity,
      {
        getBatchEntries: (item) => {
          if (!item || !Array.isArray(item.batch_details)) {
            return []
          }
          return item.batch_details.map(detail => ({
            batchNumber: detail && detail.batch_no,
            quantity: detail && detail.invoice_quantity
          }))
        }
      }
    )
    const countsWithInvoiceQuantities = updateCountsFromSkuQuantities(shipment.counts, invoiceQuantitiesBySku)

    const baseSnapshot = {
      ...shipment,
      counts: countsWithInvoiceQuantities,
      doCheckSent: false
    }

    // Remove unecessary fields for follow up
    const fieldsToRemove = ['shouldReturnProducts']
    fieldsToRemove.forEach(field => {
      if (baseSnapshot[field]) delete baseSnapshot[field]
    })

    if (hasSentSnapshot) {
      const followUpShipmentNo = generateShipmentNumber()
      const followUpSnapshots = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices(['new', 'sent'].map(status => ({
        ...baseSnapshot,
        status,
        shipmentNo: followUpShipmentNo,
        parentDocId: shipment.id
      })))
      if (logger && logger.warn) {
        logger.warn({
          code: 'sent-snapshot-already-exists',
          orderId: shipment.orderId,
          shipmentId: shipment.id,
          status: shipment.status,
          followUpShipmentNo
        }, 'sent snapshot already exists, creating follow ups (new + sent)')
      }
      await mainApi.shipment.createBulkSnapshots(followUpSnapshots)
      return
    }

    const [snapshotWithPrices] = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices([{
      ...baseSnapshot,
      status: 'sent'
    }])

    await mainApi.shipment.createSnapshot(snapshotWithPrices)
  }
}

module.exports = createInvoiceCallback
